import { ClinicCondition, ClinicWithConditionsAndPromo } from '../../components/Clinics/types';
import { Organisation } from '../../types/organisation';
import { Pharmacy } from '../../types/pharmacy';
import { User } from '../users';

export interface GetClinicsResponse {
  data: ClinicWithConditionsAndPromo[];
  total: number;
}

export interface GetClinicResponse {
  data: ClinicWithConditionsAndPromo[];
}

export interface GetClinicConditionsResponse {
  data: {
    clinic_conditions: ClinicWithConditionsAndPromo['clinic_conditions'];
  };
}

export interface Clinic {
  name: string;
  selection_visibility?: string;
  internal_prescribing: boolean;
  internal_product_charge: boolean;
  esignature_enabled: boolean;
  fulfilment_type?: FulfilmentTypeEnum | null;
  spotlight_condition_id?: string | null;
}

export interface PaginationParams {
  page: number;
  limit: number;
}

export interface Pagination {
  total: number;
  previous: number | null;
  next: number | null;
  current_page: number;
}

export interface GetListingOrganisationsResponse {
  data: Organisation[];
  pagination: Pagination;
}

export interface AddListingOrganisationRequest {
  organisation_id: string;
}

export type AddListingOrganisationResponse = { data: Organisation };

export interface Fulfilment {
  _id: string;
  organisation?: Organisation;
  pharmacy?: Pharmacy;
}

export interface GetFulfilmentsResponse {
  data: Fulfilment[];
  pagination: Pagination;
}

export interface AddFulfilmentRequest {
  organisation_id?: string | undefined;
  pharmacy_id?: string | undefined;
}

export interface AddFulfilmentResponse {
  data: Fulfilment;
}

export enum FulfilmentType {
  ORGANISATION = 'organisation',
  PHARMACY = 'pharmacy',
}

export enum FulfilmentVisibility {
  GLOBAL_DEFAULT = 'global_default',
}

export enum FulfilmentTypeEnum {
  MARKETPLACE = 'marketplace',
  SPECIFIC_ORGANISATIONS = 'specific_organisations',
  WITHIN_LISTING_ORGANISATION_NETWORK = 'within_listing_organisation_network',
  NONE = 'none'
}

export interface CreateClinicConditionResponse {
  data: ClinicCondition;
}

export interface GetClinicPrescribersResponse {
  data: User[];
}

export interface GetExcludedOrganisationsResponse {
  data: Organisation[];
  pagination: Pagination;
}

export interface AddExcludedOrganisationRequest {
  organisation_id: string;
}

export type AddExcludedOrganisationResponse = { data: Organisation };
